exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recipe[data-v-07c6caf1]{background-color:#222;margin-top:10px;border-radius:5px;padding-top:1px;padding-bottom:20px}.recipe>h2[data-v-07c6caf1]{text-align:center;font-weight:bolder;margin-bottom:0}.recipe h3[data-v-07c6caf1]{text-align:center;font-weight:lighter;font-style:italic;margin-top:0}.recipe .steps[data-v-07c6caf1]{display:flex;flex-direction:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-07c6caf1","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Recipe.vue
// module id = 87
// module chunks = 0